import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { UserProfile, Users } from "../../../Constant";
import UserData from "./ProfileUser/UserData";
import FirstData from "./FirstData";
import SecondData from "./SecondData";
import ThirdData from "./ThirdData";
import ForthData from "./ForthData";

const UserProfileContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={UserProfile} parent={Users} title={UserProfile} />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <UserData/>
            <FirstData/>
            <SecondData/>
            <ThirdData/>
            <ForthData/>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default UserProfileContainer;
